<template>
    <div class="app">
        <AppHeader></AppHeader>
        <div class="app-body">
            <Sidebar></Sidebar>
            <main class="main">
                <sla-reminders></sla-reminders>
                <event-reminders></event-reminders>
                <div class="container-fluid mb-4 main-content-mt">
                    <alerts></alerts>
                    <global-notifications></global-notifications>
                    <slot></slot>
                </div>
            </main>
        </div>
    </div>
</template>

<script>

    import AppHeader from '../components/Header';
    import Sidebar from '../components/Sidebar';
    import Alerts from '../components/Alerts/Alerts';
    import GlobalNotifications from "../components/Alerts/GlobalNotifications";
    import SlaReminders from '../components/Alerts/SlaReminders';
    import EventReminders from '../components/Alerts/EventReminders';

    export default {

        name: 'layout',

        components: {GlobalNotifications, AppHeader, Sidebar, Alerts, SlaReminders, EventReminders},

        computed: {
            name() {
                return this.$route.name;
            },
            list() {
                return this.$route.matched;
            }
        }

    };
</script>



// WEBPACK FOOTER //
// src/containers/Layout.vue